var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose18LineCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9508 4.95079L13.0508 4.05078L9.00078 8.10078L4.95078 4.05078L4.05078 4.95079L8.09703 9.00079L4.05078 13.0508L4.95078 13.9508L9.00078 9.90077L13.0508 13.9508L13.9508 13.0508L9.90078 9.00079L13.9508 4.95079Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose18LineCurrent);
export default __webpack_public_path__ + "static/media/icon_close_18_line_current.4c1475bb8ff88cb224341c886c9a9523.svg";
export { ForwardRef as ReactComponent };